import { render, staticRenderFns } from "./ManagePatientAddComplete.vue?vue&type=template&id=aa85b9be&scoped=true&"
import script from "./ManagePatientAddComplete.vue?vue&type=script&lang=ts&"
export * from "./ManagePatientAddComplete.vue?vue&type=script&lang=ts&"
import style0 from "./ManagePatientAddComplete.vue?vue&type=style&index=0&id=aa85b9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa85b9be",
  null
  
)

export default component.exports